import { Component } from '@angular/core';
import { UsersSearchService } from 'src/app/components/search/users-search.service';
import { RelationRequestTableFactory } from 'src/app/components/user-relation-requests/grid-table-factory/user-relation-requests-table';
import { ConnectionTableFactory } from '../../grid-table-factory';
import { SuggestedUserTable } from '../../grid-table-factory/connection-tables/suggested-user-table';
import { UserSearchTableConstructor } from '../../grid-table-factory/search-table';
import { RELATION_REQUESTS_PAGE_CONFIG, RELATION_REQUESTS_TABLES } from '../../relation-request.tokens';
import { ConnectionRequestService } from '../../services/connection-request.service';
import { UserRelationRequestService } from '../../services/relation-request.service';
import { ManageRelationRequestComponent } from '../manage-relation-request/manage-relation-request.component';
import { CONNECTION_PAGE_CONFIG, CONNECTION_TABLES, ConnectionRequestComponent } from './manage-connection';

@Component({
  selector: 'connections-page',
  templateUrl: './connections-page.html',
  styleUrls: ['./connections-page.component.scss'],
  providers: [
    UsersSearchService,
    { provide: ManageRelationRequestComponent, useClass: ConnectionRequestComponent },
    { provide: UserRelationRequestService, useClass: ConnectionRequestService },
    { provide: RelationRequestTableFactory, useClass: ConnectionTableFactory },
    { provide: UserSearchTableConstructor, useClass: SuggestedUserTable },
    { provide: RELATION_REQUESTS_TABLES, useValue: CONNECTION_TABLES },
    { provide: RELATION_REQUESTS_PAGE_CONFIG, useValue: CONNECTION_PAGE_CONFIG },
  ],
})
export class ConnectionsPageComponent {}
